export function injectMouseFlowScript(userSession) {
  var _ref = userSession !== null && userSession !== void 0 ? userSession : {},
    mouseflowScript = _ref.mouseflowScript;
  if (mouseflowScript) {
    var _scriptElement = document.createElement("script");
    _scriptElement.innerHTML = mouseflowScript;
    document.body.appendChild(_scriptElement);
  }
}